import React, { useContext } from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext, grid } from '@shared/styles';

interface Props {
  onPress(): void;
}

export function SignatureClearButton({ onPress }: Props) {
  const colors = useContext(ColorThemeContext);
  return (
    <MBTouchableOpacity
      style={{ padding: grid(1), alignSelf: 'flex-end', position: 'absolute', zIndex: 2 }}
      onPress={onPress}
    >
      <MBView
        style={[
          {
            backgroundColor: colors.input.borderInactive,
            height: 24,
            width: 24,
            borderRadius: 12,
          },
        ]}
      >
        <View flex centerVertically centerHorizontally>
          <MBIconV2 name={'remove-x'} size={40} color={colors.background} />
        </View>
      </MBView>
    </MBTouchableOpacity>
  );
}
